import { render } from "./NewChildActivities.vue?vue&type=template&id=8a8cfaf2&scoped=true"
import script from "./NewChildActivities.vue?vue&type=script&lang=js"
export * from "./NewChildActivities.vue?vue&type=script&lang=js"

import "./NewChildActivities.vue?vue&type=style&index=0&id=8a8cfaf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8cfaf2"]])

export default __exports__